export const formattingDate = (date) => {
  // Check for invalid date
  if (!(date instanceof Date) || isNaN(date)) {
    return ""; // Return empty if the input is invalid
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const displayDate = (date) => {
  if (!date) return "";
  try {
    return new Date(date).toLocaleDateString([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch (err) {
    console.error("Invalid date in formatDate:", date, err);
    return "";
  }
};

export const displayTime = (date) => {
  if (!date) return "";
  try {
    return new Date(date).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (err) {
    console.error("Invalid date in formatTime:", date, err);
    return "";
  }
};

export const formatDateString = (dateString) => {
  const month = dateString.slice(0, 2);
  const day = dateString.slice(2, 4);
  const year = dateString.slice(4);
  return `${parseInt(month)}/${parseInt(day)}/${year}`;
};

const CENTRAL_AMERICA_TZ = "America/Guatemala";

export const getCentralAmericaDate = () => {
  const now = new Date();
  const options = {
    timeZone: CENTRAL_AMERICA_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  const parts = new Intl.DateTimeFormat("en-US", options).formatToParts(now);
  const month = parts.find(p => p.type === "month").value;
  const day = parts.find(p => p.type === "day").value;
  const year = parts.find(p => p.type === "year").value;
  return `${month}/${day}/${year}`;
};

export const getCentralAmericaTime = () => {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: CENTRAL_AMERICA_TZ,
    hour12: true,
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date());
};



